import { render, staticRenderFns } from "./header.vue?vue&type=template&id=0471bc5c&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=0471bc5c&prod&lang=css"
import style1 from "./header.vue?vue&type=style&index=1&id=0471bc5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0471bc5c",
  null
  
)

export default component.exports